import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  useCreateGroupMutation,
  useEffect,
  toast,
  Button,
  useState,
  GetCookie,
} from "../../Libraries/Screens/index";
import {
  swal,
} from "../../Libraries/Post/GetAllPostRelatedToScreen/AllPosts/index";
import ModalComp from '../../components/Modal';
import Groupmodalimg from "../../Assets/Images/groupmodalimg.png"

const options = [
  "Rename",
  "Delete Group",
];
export default function Groupoptions({groupdata, onGroupUpdate}) {
  const [group] = useCreateGroupMutation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [error, setError] = useState("");
  const [maxerror, setmaxerror] = useState(true);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
  setAnchorEl(event.currentTarget);
};
const selectionhandle= async (option) =>{
    const groupid = groupdata.ser_collection_id;
    if(option === 'Delete Group'){
       swal({
          title: "Delete Group!",
          text: "Are you sure you want to delete the group?",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then(async (willUnLink) => {
          if (willUnLink) {
              const customerid = localStorage.getItem("txt_customer_id");
              const creategroupdata = new FormData();
              creategroupdata.append("function", "DELETE_GROUP");
              creategroupdata.append("txt_customer_id", customerid);
              creategroupdata.append("ser_collection_id", groupid);
              creategroupdata.append("security_token", await GetCookie("es_token"));
            try {
            const response = await group(creategroupdata);
            if(response.data.status === "true"){
            toast.success(response.data.message);
            if (onGroupUpdate) onGroupUpdate();
            }else{
                toast.error(response.data.message);
            }
            
        } catch (error) {
        console.error("Error creating group:", error);
        }
         }
    });

    }else{
      if(option === 'Rename'){
        setGroupName(groupdata.txt_collection_name); 
        setIsModalOpen(true);
}
    }
}
const openAddGroupModal = () => {
    setIsModalOpen(true);
  };
const updategroupname = async () => {
    const groupid = groupdata.ser_collection_id;
    const customerid = localStorage.getItem("txt_customer_id");
    const creategroupdata = new FormData();
    creategroupdata.append("function", "UPDATE_GROUP");
    creategroupdata.append("txt_customer_id", customerid);
    creategroupdata.append("ser_collection_id", groupid);
    creategroupdata.append("security_token", await GetCookie("es_token"));
    creategroupdata.append("txt_collection_name", groupName);
        try {
        const response = await group(creategroupdata);
          if(response.data.status === "true"){
            toast.success(response.data.message);
            closeModal();
            onGroupUpdate();
          }else{
              toast.error(response.data.message);
            }
        }catch (error) {
          console.error("Error creating group:", error);
    }
            
}

      const allowedPattern = /^[a-zA-Z0-9 .,()_\-]+$/;

      const handleInputChange = (e) => {
        let inputText = e.target.value;
        if (inputText && !allowedPattern.test(inputText)) {
          toast.error("Invalid characters entered.");
          inputText = inputText.replace(/[^a-zA-Z0-9 .,()_\-]/g, ""); 
        }
        setGroupName(inputText);
        const textinput = inputText.trim().length;
    
        // let counttext = inputText.trim().replace(/\s+/g, " ");
        // const charCountWithoutSpaces = counttext.replace(/\s/g, "").length;
        // if (charCountWithoutSpaces > 50) {
        if (textinput > 50) {
          setmaxerror(true);
          setError("Name must be 0–50 characters allowed.");
        } else {
          setError("");
          setmaxerror(false);
        }
      };


const renderModalContent = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center py-4">
      <div
        className="d-flex flex-column justify-content-center align-items-center gap-2 w-75"
        style={{ fontFamily: "Roboto, sans-serif" }}
      >
        <img src={Groupmodalimg} width={151} height={151} alt="Group" />
        <h3 className="fs-24 fw-semibold">Rename Group</h3>
        <p className="text-center fs-16" style={{ color: "#00000099" }}>
          Enter a new name for your group.
        </p>
        {error && (
        <div style={{ color: "red", marginTop: "4px", fontSize: "14px" }}>
          {error}
        </div>
        )}
        <input
          style={{ border: "1px solid #333333" }}
          className="flex form-control border-1"
          type="text"
          placeholder="Group name"
          value={groupName}
          onChange={handleInputChange}
        />
        <Button
          variant="contained"
          sx={{ width: "100%", mt: 2 }}
          onClick={updategroupname}
          disabled={maxerror}
          className='capitalized fs-14 fw-bold'
        >
          Rename
        </Button>
      </div>
    </div>
  );
};

const closeModal = () => {
    setIsModalOpen(false);
    setError("");
    setmaxerror(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
       <ModalComp
                open={isModalOpen}
                onCloseModal={closeModal}
                modalwidth={"40%"}
                modalheight={"520px"}
                closeicon ={true}
              >
                {renderModalContent()}
              </ModalComp>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {options?.map((option, index) => (
          <MenuItem
            key={index}
           onClick={() => {
                selectionhandle(option); 
                handleClose();   
                }}
            >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
